import React from 'react';

export const GENERAL_SECTION_ITEMS_LABELS: { [key: string]: string } = {
  Status: 'Status',
  Terms: 'Terms',
  Privacy: 'Privacy',
  Accessibility: 'Accessibility',
  Cookies: 'Cookies',
  'Manage Cookie Preferences': 'Manage Cookie Preferences',
  'Do Not Sell or Share My Personal Information': 'Do Not Sell or Share My Personal Information',
};

interface LinkItem {
  path?: string;
  url?: string;
  rel?: string;
  isHelpCenterLink?: boolean;
  // eslint-disable-next-line no-unused-vars
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const generalLinks: {
  // eslint-disable-next-line no-unused-vars
  [key in keyof typeof GENERAL_SECTION_ITEMS_LABELS]: LinkItem;
} = {
  [GENERAL_SECTION_ITEMS_LABELS.Status]: {
    url: 'https://www.eventbritestatus.com/',
  },
  [GENERAL_SECTION_ITEMS_LABELS.Terms]: {
    // Relative on purpose: /corporate/legal/legalterms/ is localized per TLD,
    // while the legacy /l/legalterms/ MLP 404s outside the English storefronts.
    path: '/corporate/legal/legalterms/',
  },
  [GENERAL_SECTION_ITEMS_LABELS.Privacy]: {
    path: '/help/{LOCALE}/articles/460838/eventbrite-privacy-policy/',
    rel: 'nofollow',
    isHelpCenterLink: true,
  },
  [GENERAL_SECTION_ITEMS_LABELS.Accessibility]: {
    // Absolute .com URL (like Impact): the legacy /l/accessibility/ MLP was
    // removed, and /corporate/accessibility/ is only published on English TLDs.
    url: 'https://www.eventbrite.com/corporate/accessibility/',
  },
  [GENERAL_SECTION_ITEMS_LABELS.Cookies]: {
    path: '/help/{LOCALE}/articles/666792/eventbrite-cookie-policy/',
    rel: 'nofollow',
    isHelpCenterLink: true,
  },
};

const privacyLinks: {
  // eslint-disable-next-line no-unused-vars
  [key in keyof typeof GENERAL_SECTION_ITEMS_LABELS]: LinkItem;
} = {
  [GENERAL_SECTION_ITEMS_LABELS['Manage Cookie Preferences']]: {
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      (window as any)?.transcend?.showConsentManager?.({
        viewState: 'CompleteOptions',
      });
    },
  },
  [GENERAL_SECTION_ITEMS_LABELS['Do Not Sell or Share My Personal Information']]: {
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      (window as any)?.transcend?.showConsentManager?.({
        viewState: 'DoNotSellExplainer',
      });
    },
  },
};

export const GENERAL_SECTION_ITEMS = { ...generalLinks, ...privacyLinks };
